export type SpotLieClaim = { text: string; isLie: boolean; conceptId: string };
export type SpotLieRound = { intro: string; claims: SpotLieClaim[] };

const ROLES = "act_scope_roles";
const HIGH = "act_high_risk";
const OPS = "act_obligations_ops";
const OFF = "ai_office_enforcement";
const RAG = "generative_rag";

export const EPSO_AD8_AI_SPOTLIE_DECK: readonly SpotLieRound[] = [
  {
    intro: "A colleague explains who writes high-risk technical documentation:",
    claims: [
      {
        text: "The provider must draw up the technical documentation for a high-risk system placed on the market.",
        isLie: false,
        conceptId: ROLES,
      },
      {
        text: "The deployer draws up that technical documentation as their main Article 16 duty.",
        isLie: true,
        conceptId: ROLES,
      },
      {
        text: "A notified body assesses conformity; it is not the author of the provider’s file.",
        isLie: false,
        conceptId: ROLES,
      },
    ],
  },
  {
    intro: "Someone summarises when Annex III high-risk obligations apply:",
    claims: [
      {
        text: "After the Digital Omnibus, Chapter III sections 1–3 for Annex III apply from 2 December 2027.",
        isLie: false,
        conceptId: HIGH,
      },
      {
        text: "Annex III high-risk obligations have applied since 2 August 2026.",
        isLie: true,
        conceptId: HIGH,
      },
      {
        text: "GPAI Chapter V duties already applied from 2 August 2025.",
        isLie: false,
        conceptId: HIGH,
      },
    ],
  },
  {
    intro: "On Article 4 literacy after the 2026 amendment:",
    claims: [
      {
        text: "Providers and deployers must take measures to support AI literacy of staff and persons using systems on their behalf.",
        isLie: false,
        conceptId: OPS,
      },
      {
        text: "Article 4 requires every staff member to reach a certified literacy level.",
        isLie: true,
        conceptId: OPS,
      },
      {
        text: "The text says the obligation does not require guaranteeing any specific level of literacy.",
        isLie: false,
        conceptId: OPS,
      },
    ],
  },
  {
    intro: "On the Article 6(3) derogation:",
    claims: [
      {
        text: "A narrow procedural Annex III system can fall outside high-risk if it poses no significant rights or safety risk.",
        isLie: false,
        conceptId: HIGH,
      },
      {
        text: "A 6(3) derogation still applies when the system profiles natural persons.",
        isLie: true,
        conceptId: HIGH,
      },
      {
        text: "The provider who relies on 6(3) must document the assessment and register.",
        isLie: false,
        conceptId: HIGH,
      },
    ],
  },
  {
    intro:
      "On who supervises a same-undertaking GPAI-based consumer system (Article 75 exceptions aside):",
    claims: [
      {
        text: "The AI Office has exclusive competence over that system’s provider.",
        isLie: false,
        conceptId: OFF,
      },
      {
        text: "The national market surveillance authority exclusively supervises that system in every case.",
        isLie: true,
        conceptId: OFF,
      },
      {
        text: "Deployers outside that undertaking stay under national supervision.",
        isLie: false,
        conceptId: OFF,
      },
    ],
  },
  {
    intro: "On RAG versus fine-tuning:",
    claims: [
      {
        text: "RAG retrieves documents at inference and leaves model weights unchanged.",
        isLie: false,
        conceptId: RAG,
      },
      {
        text: "RAG updates model weights; fine-tuning retrieves documents at inference.",
        isLie: true,
        conceptId: RAG,
      },
      {
        text: "Fine-tuning changes weights; it is not a substitute for a current document store.",
        isLie: false,
        conceptId: RAG,
      },
    ],
  },
];
